import type { ComponentStyleConfig } from "@chakra-ui/theme";
import { colors } from "../../colors";

export const Text: ComponentStyleConfig = {
	baseStyle: {
		fontFamily: ["SF Pro", "Roboto"],
		color: colors.text.muted,
	},
	defaultProps: {
		fontWeight: "medium",
	},
	sizes: {
		lg: {
			fontSize: {
				base: "md",
				lg: "lg",
			},
			lineHeight: {
				base: "xl",
				lg: "2xl",
			},
		},
		md: {
			fontSize: {
				base: "sm",
				lg: "md",
			},
			lineHeight: {
				base: "xl",
				lg: "xl",
			},
		},
		sm: {
			fontSize: {
				base: "xs",
				lg: "sm",
			},
			lineHeight: {
				base: "lg",
				lg: "xl",
			},
		},
	},
};
